var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("generic-modal", {
    attrs: {
      id: _vm.id,
      "loaders-disabled": "",
      "modal-class": "account-plan-message-modal",
    },
    on: {
      show: function ($event) {
        return _vm.$emit("show", $event)
      },
      hide: function ($event) {
        return _vm.$emit("hide", $event)
      },
    },
    scopedSlots: _vm._u(
      [
        {
          key: "header-custom",
          fn: function () {
            return [
              _c(
                "h4",
                { staticClass: "modal-title bold text-white" },
                [_vm._t("header")],
                2
              ),
            ]
          },
          proxy: true,
        },
        {
          key: "body",
          fn: function () {
            return [_vm._t("body")]
          },
          proxy: true,
        },
        {
          key: "footer",
          fn: function () {
            return [_vm._t("footer")]
          },
          proxy: true,
        },
      ],
      null,
      true
    ),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }